import type { ReactNode } from 'react';
import Icon from '@components/common/Icon';

export interface FormSectionProps {
    title?: string;
    icon?: ReactNode;
    isOpen?: boolean;
    onToggle?: () => void;
    children: ReactNode;
    className?: string;
    headerActions?: ReactNode;
}

const FormSection = ({ title, icon, isOpen, onToggle, children, className = '', headerActions }: FormSectionProps) => (
    <div className={`bg-white border border-[var(--neutral-color)] rounded-2xl mb-4 2xl:mb-5 overflow-hidden ${className}`}>
        <div
            className={`flex items-center justify-between px-2 2xl:px-5 py-1.5 2xl:py-2.5 select-none rounded-t-2xl ${isOpen ? 'bg-[var(--primary-subtle-color)]' : 'bg-white'}`}
        >
            {/* Left: icon + title — clicking this toggles */}
            <div className="flex items-center gap-2.5 cursor-pointer flex-1" onClick={onToggle}>
                {icon && (
                    <span className="flex items-center justify-center shrink-0 w-[26px] 2xl:w-[30px] h-[26px] 2xl:h-[30px] bg-[var(--primary-surface-color)] rounded-full">
                        {icon}
                    </span>
                )}
                <span className="text-[13px] 2xl:text-lg font-medium text-[var(--secondary-color)]">{title}</span>
            </div>

            {/* Right: optional header actions + collapse arrow */}
            <div className="flex items-center gap-3">
                {headerActions && (
                    <div onClick={e => e.stopPropagation()}>{headerActions}</div>
                )}
                <span className={`cursor-pointer ${isOpen ? '' : 'rotate-270'}`} onClick={onToggle}>
                    <Icon name="downarrow" className='w-[10px] 2xl:w-[13px] h-auto' alt="" />
                </span>
            </div>
        </div>

        {/* ── Body ────────────────────────────────────────────────── */}
        {isOpen && <div className="p-2 md:p-4 2xl:p-5 rounded-2xl">{children}</div>}
    </div>
);

export default FormSection;
